import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Box,
  Button,
  SimpleGrid,
  useColorModeValue
} from "@chakra-ui/react";
import FormClient from "./components/Form";
import ClientsTable from "./components/Table";
import useClients from "./hooks/useClients";

export default function Clients() {
  const textColor = useColorModeValue("navy.700", "white");
  const brandStars = useColorModeValue("brand.500", "brand.400");

  const {
    clientes,
    errorCliente,
    loading,
    showPessoa,
    showDelete,
    showFormPessoa,
    saveCliente,
    nomeClinteRef,
    idTipoRef,
    classificacaoRef,
    documentoRef,
    razaoSocialRef,
    nomeFantasiaRef,
    inscricaoMunicipalRef,
    inscricaoEstadualRef,
    contribuinteRef,
    classificacaoList,
    tipoPessoaList,
    bairroRef,
    cepRef,
    cidadeRef,
    complementoRef,
    estadoRef,
    numeroRef,
    principalRef,
    ruaRef,
    enderecoList,
    loadCEP,
    viaCepEnd,
    adicionarEndereco,
    deleteEnd,
    contatoList,
    deleteContato,
    adicionarContato,
    cancelPessoaRef,
    closeErrorPessoa,
    editPessoa,
    deletePessoa,
    cancelDeleteRef,
    closeDelete,
    showDeletePessoa,
    client,
    cargoContatoRef,
    emailContatoRef,
    nomeContatoRef,
    principalContatoRef,
    telefoneContatoRef,
    changeItemPessoa,
    filial,
    changeFilial,
    pessoaFilial,
    errorMsgCliente,
    errorTitleCliente,
    contaList,
    bancoRef,
    agenciaRef,
    tipoRef,
    numeroContaRef,
    titularRef,
    tipoPessoaRef,
    documentoContaRef,
    descricaoRef,
    obsRef,
    deleteConta,
    adcionarConta
    
  } = useClients();
  return (
    <Box pt={{ base: "130px", md: "80px", xl: "80px" }}>
      <SimpleGrid
        mb="20px"
        columns={{ sm: 1, md: 1 }}
        spacing={{ base: "20px", xl: "20px" }}
      >
        <ClientsTable
          clients={clientes}
          showForm={showFormPessoa}
          edit={editPessoa}
          cancelRef={cancelDeleteRef}
          closeDelete={closeDelete}
          deletar={showDeletePessoa}
          remove={deletePessoa}
          showDelete={showDelete}
 
        />

        <FormClient
          enderecoList={enderecoList}
          accountSelected={client}
          brandStars={brandStars}
          error={errorCliente}
          loading={loading}
          save={saveCliente}
          nomeRef={nomeClinteRef}
          show={showPessoa}
          showModal={showFormPessoa}
          textColor={textColor}
          idTipoRef={idTipoRef}
          classificacaoRef={classificacaoRef}
          documentoRef={documentoRef}
          razaoSocialRef={razaoSocialRef}
          nomeFantasiaRef={nomeFantasiaRef}
          inscricaoMunicipalRef={inscricaoMunicipalRef}
          inscricaoEstadualRef={inscricaoEstadualRef}
          contribuinteRef={contribuinteRef}
          classificacaoList={classificacaoList}
          tipoPessoaList={tipoPessoaList}
          bairroRef={bairroRef}
          cepRef={cepRef}
          ruaRef={ruaRef}
          numeroRef={numeroRef}
          complementoRef={complementoRef}
          cidadeRef={cidadeRef}
          estadoRef={estadoRef}
          principalRef={principalRef}
          loadCEP={loadCEP}
          viaCepEnd={viaCepEnd}
          adicionarEnd={adicionarEndereco}
          deleteEnd={deleteEnd}
          contatoList={contatoList}
          deleteContato={deleteContato}
          adicionarContato={adicionarContato}
          cargoContatoRef={cargoContatoRef}
          emailContatoRef={emailContatoRef}
          nomeContatoRef={nomeContatoRef}
          principalContatoRef={principalContatoRef}
          telefoneContatoRef={telefoneContatoRef}
          changeItem={changeItemPessoa}
          filial={filial}
          changeFilial={changeFilial}
          pessoaFilial={pessoaFilial}
          adcionarConta={adcionarConta}
          agenciaRef={agenciaRef}
          bancoRef={bancoRef}
          contaList={contaList}
          deleteConta={deleteConta}
          descricaoRef={descricaoRef}
          documentoContaRef={documentoContaRef}
          numeroContaRef={numeroContaRef}
          obsRef={obsRef}
          tipoPessoaRef={tipoPessoaRef}
          tipoRef={tipoRef}
          titularRef={titularRef}
           
          

        />
      </SimpleGrid>

      <AlertDialog
        isOpen={errorCliente}
        leastDestructiveRef={cancelPessoaRef}
        onClose={closeErrorPessoa}
        isCentered
        motionPreset="slideInBottom"
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
             {errorTitleCliente}
            </AlertDialogHeader>

            <AlertDialogBody>
            {errorMsgCliente}
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button
                ref={cancelPessoaRef}
                onClick={closeErrorPessoa}
                colorScheme={"blue"}
              >
                OK
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>

    </Box>
  );
}
